// src/utils/modalHelper.js
export function openContactModal() {
    const modalEl = document.getElementById('contactModal');
    if (modalEl) {
      import('bootstrap').then(({ Modal }) => {
        const contactModal = new Modal(modalEl);
        contactModal.show();
      });
    }
  }